package com.neurobs.react

import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.ReactElement
import slinky.web.html.{className, div, i, onClick, span}

@react object Card {
	case class Props
	(
		title: Option[String],
		onClose: Option[() => Unit],
		onRefresh: Option[() => Unit],
		fullWidth: Boolean,
		dark: Boolean,
		children: ReactElement*
	)

	val component = FunctionalComponent[Props] { props =>
		Panel(fullWidth = props.fullWidth, dark = props.dark)(
			includeIf(props.title.isDefined || props.onClose.isDefined)(
				div(className := "nfw-card-header")(
					AlignedLine(
						AlignedLineLeft(
							props.onRefresh map { onRefresh =>
								RefreshButton(onClick = onRefresh)
							}
						),
						AlignedLineCenter(span(className := "nfw-card-title")(props.title)),
						AlignedLineRight(
							props.onClose map { onClose =>
								i(
									className := "fa-solid fa-xmark nfw-close-button",
									onClick := onClose
								)
							}
						)
					)
				)
			),
			div(props.children:_*)
		)
	}
}
